<template>
  <section class="section height-100">
    <div class="tile is-ancestor full-width is-vertical height-100">
        <div class="tile is-parent is-horizontal">
          <dashboard-banner-tile
            :title="$t('Solicitudes')"
            :subtitle="
              $t('Aprovecha al maximo la tecnologia que te permite Myneo 40')
            "
            :ctaText="$t('Acceder')"
            ctaTarget="onBoard.neofintech.myNeofintechRequests"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-solicitudes.jpg"
          ></dashboard-banner-tile>

          <dashboard-banner-tile
            :title="$t('Reunion')"
            :subtitle="
              $t(
                'Solicita una reunion con la app que mas se adapte a tu dispositivo'
              )
            "
            :ctaText="$t('Acceder')"
            ctaTarget="https://ecobanka.com/formulario-de-contacto-ecobanka"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-reunion.jpg"
          >
            <div class="level" style="background: var(--rosa-eco);padding: 15px; border-radius: 10px; margin-top: 10px;" >
              <div class="level-item">
                <img src="~@/assets/icons/telegram_logo_36.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Telegram</h4>
              </div>
              <div class="level-item">
                <img src="~@/assets/icons/whatsapp_logo_36.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Whatsapp</h4>
              </div>
              <div class="level-item">
                <img src="~@/assets/icons/google_meet_48.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Meet</h4>
              </div>
            </div>
          </dashboard-banner-tile>
        </div>

        <div class="tile is-parent">
            <iframe
              width="100%"
              style="height: 360px;"
              src="https://www.youtube.com/embed/videoseries?list=PL3DOb74zZ2pOS2wc4GdEkL1c7fW3E0KTz"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="tile is-child"
            ></iframe>
         <dashboard-banner-tile
              :title="$t('Compartimos experiencias')"
              :ctaText="$t('Acceder')"
              backgroundImage="https://ecobanka.com/wp-content/uploads/2018/05/Trama_tv.jpg"
              ctaTarget="https://ecobanka.com"
            ></dashboard-banner-tile>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  props: ['id'],
  components: {DashboardBannerTile},
  mounted() {
    this.getMyNeofintechRequests()
  },
  data() {
    return {
      myNeofintechRequests: []
    }
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequests']),
    goToRequestDetail(id) {
      this.$router.push({
        name: 'onBoard.neofintech.myNeofintechRequestDetail',
        params: { id: id }
      })
    },
    getMyNeofintechRequests: function() {
      let self = this
      self.request(() =>
        self.getOnboardRequests().then(function(response) {
          self.myNeofintechRequests = response.data
        })
      )
    }
  }
}
</script>

<style></style>
